import React from 'react';
import Typography from '@digital-hig/mui/dist/Typography';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DOMPurify from 'isomorphic-dompurify';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Skeleton from 'react-loading-skeleton';

const Announcements = ({
  showLoader, data, sectionRef, sectionId,
}) => (
  <RootElement ref={sectionRef} data-id={sectionId}>
    {showLoader ? <Skeleton height={72} />
      : (
        <Grid xs={12} lg={8}>
          <Typography component="h2" variant="header-copy-medium">Announcements</Typography>
          <Typography dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data) }} />
        </Grid>
      )}
  </RootElement>
);

const RootElement = styled.div`
    margin-bottom: 65px;
`;

Announcements.propTypes = {
  showLoader: PropTypes.bool,
  sectionRef: PropTypes.shape({}).isRequired,
  sectionId: PropTypes.isRequired,
  data: PropTypes.string,
};

Announcements.defaultProps = {
  showLoader: false,
  data: '',
};

export default React.memo(Announcements);
